import NavBarWizardBaseCtrl from 'edge/platform/widgets/wizard/NavBarWizardBaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default [
    '$scope', '$element', '$filter', 'StateUtils', '$state', '$location', '$q', '$cookies', 'SearchService', 'UserService', '$stateParams', '$injector', '$sanitize', 'UserInfoService', 'NavBarItems', 'qnb.CustomQuoteService', 'ViewModelService',
    function ($scope, $element, $filter, StateUtils, $state, $location, $q, $cookies, SearchService, UserService, $stateParams, $injector, $sanitize, UserInfoService, NavBarItems, CustomQuoteService, ViewModelService) {

        // PSA shown as separate menu for Producer/Vendor only (Vendor Only has it as Dashboard, Agent Only - doesn't have it at all)
        $scope.claimsFeatureTurnedOn = ApplicationFeatures.getAllFeatures().gatewayclaims === 'true' && ApplicationFeatures.hasFeature('role.vendor') && ApplicationFeatures.hasFeature('role.producer'); // PSA
        $scope.serviceRequestsFeatureTurnedOnPSA = ApplicationFeatures.getAllFeatures().serviceRequests === 'true'; // PSA
        $scope.activitiesTurnedOnPSA = ApplicationFeatures.getAllFeatures().disableActivities_PSA !== 'true'; // PSA
        $scope.ccActivitiesTurnedOnPSA = ApplicationFeatures.hasFeature('role.producer'); // PSA
        $scope.serviceMessagesTurnedOnPSA = ApplicationFeatures.getAllFeatures().serviceMessages_PSA === 'true'; // PSA
        $scope.accountAndPoliciesTurnedOnPSA = ApplicationFeatures.hasFeature('role.producer'); // PSA
        $scope.fnolTurnedOnPSA = ApplicationFeatures.hasFeature('role.vendor'); // PSA
        const infoCenterFeatureTurnedOn = ApplicationFeatures.getAllFeatures().gatewayAnalytics === 'true';
        //UCWPRODENG-875 
        if(window.isPCUser ==  true){
            $scope.claimsFeatureTurnedOn = false ;
            $scope.fnolTurnedOnPSA = false;
        }
        const baseNavbarCtrl = new NavBarWizardBaseCtrl($scope, $element);
        const ctrl = Object.create(baseNavbarCtrl);
        ctrl.init = () => {
            $scope.isSuperuser = PSAUSER.isSuperuser;
            initialiseScopeLevelVariables();
            $scope.menuItems = NavBarItems;
            $scope.isAgent = UserInfoService.isAgent();

            var RedWireDTO = {};
            $scope.submissionView = ViewModelService.create(RedWireDTO, 'pc', 'edge.capabilities.quote.submission.dto.RedWireRuleDTO');
            $scope.$watch('submissionView.country.value', (newValue) => {
                ctrl.getRedWireMesg();
            });

            //UCWPRODENG-810
            const producerCodesPromise = UserService.getAvailableProducerCodesForCurrentUser();
            var producerCodes = [];
            producerCodesPromise.then((producerCodesResponse) => {
                producerCodesResponse.forEach(function(producer){
                    producerCodes.push(producer.code);
                })
                
                $scope.producerCodes = producerCodes.length > 0 ? producerCodes.join(", ") :"";    
        });

        };

        /* Private Functions*/
        function initialiseScopeLevelVariables() {
            $scope.$state = $state;
            $scope.currentState = $state;
            $scope.canCreateSubmission = false;
            $scope.canCreateClaim = false;
            checkCreateSubmissionPermission();
            checkCreateClaimPermission();

            //$scope.canViewReports = false;
            //checkViewReportsPermission();
            //$scope.canViewReports = false;
            if (PSAUSER != undefined) {
                $scope.canViewReports = PSAUSER.isDelearLeadOrAudit;
            }
            else {
                $scope.canViewReports = false;
            }

            $scope.canViewCommissions = false;
            checkViewCommissionsPermission();

            $scope.searchRequest = {
                searchParam: ''
            };
        }

        function checkCreateSubmissionPermission() {
            const permissionDTO = {
                permission: 'createsubmission'
            };

            const permCheckPromise = UserService.hasUserSystemPermission(permissionDTO);

            permCheckPromise.then((canCreateSubmission) => {
                $scope.canCreateSubmission = canCreateSubmission;
            });
        }
        //UCWPRODENG-875
        function checkCreateClaimPermission() {
            const permissionDTO = {
                permission: 'claimcreate'
            };

            const permCheckPromise = UserService.hasUserSystemPermissionforClaim(permissionDTO, "cc");

            permCheckPromise.then((canCreateClaim) => {
                $scope.canCreateClaim = canCreateClaim;
            });
        }


        function checkViewReportsPermission() {
            let reportsConfig = [];
            const CONFIGURATION_PROVIDER = 'AGENT_REPORTS';
            if ($injector.has(CONFIGURATION_PROVIDER)) {
                // Only load the configuration in portals that provide it
                reportsConfig = $injector.get(CONFIGURATION_PROVIDER);
            }

            if (!Array.isArray(reportsConfig) || reportsConfig.length === 0) {
                $scope.canViewReports = false;
                return;
            }

            const permissionDTO = {
                permission: 'gpaviewreports'
            };

            UserService.hasUserSystemPermission(permissionDTO).then((canViewReports) => {
                $scope.canViewReports = canViewReports && infoCenterFeatureTurnedOn;
            });
        }

        function checkViewCommissionsPermission() {
            let commissionsConfig = [];
            const CONFIGURATION_PROVIDER = 'COMMISSIONS';
            if ($injector.has(CONFIGURATION_PROVIDER)) {
                // Only load the configuration in portals that provide it
                commissionsConfig = $injector.get(CONFIGURATION_PROVIDER);
            }

            if (!Array.isArray(commissionsConfig) || commissionsConfig.length === 0) {
                $scope.canViewCommissions = false;
                return;
            }

            const permissionDTO = {
                permission: 'viewcommissions'
            };

            UserService.hasUserSystemPermission(permissionDTO).then((canViewCommissions) => {
                $scope.canViewCommissions = canViewCommissions;
            });
        }

        /* Scope Functions*/
        ctrl.setNextState = () => {
            const state = $state.get($state.$current.data.actions.next);
            $state.transitionTo(state);
        };

        ctrl.getType = () => {
            return $stateParams.type;
        };

        ctrl.search = (searchRequest) => {
            const param = $sanitize(searchRequest.searchParam);
            if (param) {
                $state.go('viewSearch', {
                    'searchParam': param
                });
            }
        };

        $scope.isActivePage = (path) => {
            return $location.path() === path;
        };

        $scope.sidebarAvailable = () => {
            return ApplicationFeatures.hasFeature('mediasidebar') && $state.is('gatewayLanding');
        };
        ctrl.getRedWireMesg = function () {
            $scope.submissionView.country = UserInfoService.user.userDefaultCountry_PSA
            var currentCountry = $scope.submissionView.country.value;
            if (currentCountry !== undefined && currentCountry !== "") {
                const operation = CustomQuoteService.getRedWireMsg(currentCountry.code);
                operation.then((result) => {

                    $scope.submissionView.redWireMessage = result.redWireMessage;

                }).catch((err) => {

                });
            }
        };
        $scope.isOnAccountViewState = () => {
            return $state.includes('accounts.detail');
        };

        $scope.getAccountNumberFromStateParams = () => {
            return $stateParams.accountNumber;
        };


        return ctrl.create($scope);
    }
];
